<template>
  <v-text-field
    ref="search"
    @input="onTextChange"
    append-icon="search"
    placeholder="検索"
    background-color="white"
    solo
    class="search-box"
  />
</template>

<script>
export default {
  name: 'SimulationListSearch',
  mounted() {
    this.$refs.search.focus()
  },
  methods: {
    onTextChange(value) {
      this.$emit('onTextChange', value)
    },
  },
}
</script>

<style scoped>
.search-box {
  max-width: 250px;
}
</style>
